import { ThemeColors, getThemeFromEnv, getTheme } from '../config/themes';

let currentTheme: ThemeColors | null = null;

export const initializeTheme = (): ThemeColors => {
  const themeName = getThemeFromEnv();
  currentTheme = getTheme(themeName);
  applyThemeToDocument(currentTheme);
  return currentTheme;
};

export const applyThemeToDocument = (theme: ThemeColors): void => {
  const root = document.documentElement;
  
  root.style.setProperty('--theme-primary', theme.primary);
  root.style.setProperty('--theme-primary-dark', theme.primaryDark);
  root.style.setProperty('--theme-primary-light', theme.primaryLight);
  root.style.setProperty('--theme-primary-lighter', theme.primaryLighter);
  root.style.setProperty('--theme-light-background', theme.lightBackground);
  root.style.setProperty('--theme-primary-rgba', theme.primaryRgba);
  root.style.setProperty('--theme-primary-dark-rgba', theme.primaryDarkRgba);
  root.style.setProperty('--theme-gradient', theme.gradient);
  root.style.setProperty('--theme-gradient-horizontal', theme.gradientHorizontal);
};

export const getCurrentTheme = (): ThemeColors => {
  if (!currentTheme) {
    currentTheme = initializeTheme();
  }
  return currentTheme;
};

